import { ICommissionBreakdownObject } from '../data/entities/commission-breakdown';
import { IConfiguredHttp } from './http';

export interface ICommissionApi {

	getBookingBreakdown(propertyId: string, channelIds: string[]): Promise<ICommissionBreakdownObject>;

}

const commissionServiceApiFactory = (http: IConfiguredHttp, prefix = ''): ICommissionApi => ({
	async getBookingBreakdown(propertyId: string, channelIds: string[]) {

		if (!propertyId || !channelIds || channelIds.length <= 0) {
			throw new Error('Invalid property id or channel id');
		}
		const commissionBreakdown = {};

		for (const channel of channelIds) {

			const response = await http.get(`${prefix}/property/${propertyId}/channel/${channel}/breakdown`);

			if (!response) {
				throw new Error('Unable to retrieve breakdown');
			}

			commissionBreakdown[channel] = response;
		}

		return commissionBreakdown;
	}
});

export default commissionServiceApiFactory;
